module.exports = __webpack_public_path__ + "img/orderFail.png?3dda81d42467731398326e59030917fa";